/**
 * To get the constants from .env file.
 */
export const {
   VITE_XMPP_SOCKET_HOST,
   VITE_SSL,
   VITE_ENCRYPT_KEY,
   VITE_API_URL,
   VITE_SOCKETIO_SERVER_HOST,
   VITE_LICENSE_KEY,
   VITE_MAX_USERS_CALL,
   VITE_GOOGLE_TRANSLATE_API_KEY,
   VITE_GOOGLE_LOCATION_API_KEY,
   VITE_SKIP_OTP_LOGIN,
   VITE_SITE_DOMAIN,
   VITE_AUTOMATION_URL,
   VITE_AUTOMATION_CHROME_USER,
   VITE_AUTOMATION_CHROME_PASS,
   VITE_AUTOMATION_FIREFOX_USER,
   VITE_AUTOMATION_FIREFOX_PASS,
   VITE_AUTOMATION_EDGE_USER,
   VITE_AUTOMATION_EDGE_PASS,
   VITE_TERMS_AND_CONDITIONS,
   VITE_PRIVACY_POLICY,
   VITE_CONTACT_EMAIL,
   VITE_HIDE_NOTIFICATION_CONTENT,
   VITE_CENTRIFUGO_SOCKET_URL,
   VITE_CALLKIT_URL,
   VITE_CONTACT_SYNC,
   VITE_IS_MIRRORFLY_TEAMS,
   VITE_STORE_IN_DB,
   VITE_PRE_FETCH,
   VITE_CHAT_STORE_IN_DB,
   VITE_CHAT_PRE_FETCH,
   VITE_GROUP_STORE_IN_DB,
   VITE_GROUP_PRE_FETCH,
   VITE_OTP_RESEND_TIMEOUT,
   VITE_MAX_SCREEN_SHARES,
   VITE_MESSAGE_EDIT_TIMEOUT_MINUTES,
} = import.meta.env;

export const IS_CONTACT_SYNC_ENABLED = VITE_CONTACT_SYNC === 'true';
export const IS_MIRRORFLY_TEAMS_ENABLED = VITE_IS_MIRRORFLY_TEAMS === 'true';

// Base Sync Config
export const IS_STORE_IN_DB_ENABLED = VITE_STORE_IN_DB === 'true';
export const IS_PRE_FETCH_ENABLED = VITE_PRE_FETCH === 'true';

// Chat Sync Config (messages & recent chats)
export const IS_CHAT_STORE_IN_DB_ENABLED = (VITE_CHAT_STORE_IN_DB ?? VITE_STORE_IN_DB) === 'true';
export const IS_CHAT_PRE_FETCH_ENABLED = (VITE_CHAT_PRE_FETCH ?? VITE_PRE_FETCH) === 'true';

// Group Sync Config (group list & participants)
export const IS_GROUP_STORE_IN_DB_ENABLED = (VITE_GROUP_STORE_IN_DB ?? VITE_STORE_IN_DB) === 'true';
export const IS_GROUP_PRE_FETCH_ENABLED = (VITE_GROUP_PRE_FETCH ?? VITE_PRE_FETCH) === 'true';

// OTP Config
export const OTP_RESEND_DELAY = parseInt(VITE_OTP_RESEND_TIMEOUT || '30', 10);

// Message edit window (minutes)
export const MESSAGE_EDIT_TIMEOUT_MINUTES = parseInt(VITE_MESSAGE_EDIT_TIMEOUT_MINUTES || '15', 10);
